import{setCSSCustomProp}from"./cssCustomProperties";/**
 * Updates the page background color.
 * @param {number} width Sets the page content width.
 */export var setPageContentWidth=function setPageContentWidth(width){setCSSCustomProp('--page-content-width',"".concat(width,"px"));};